import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from 'atoms/buttons/Button';
import { SBHorizontal, Vertical } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';
import Progression from 'components/referral/Progression';
import useDestroyReferral from 'hooks/referral/useDestroyReferral';
import { glossary } from 'lib/glossary';

const ProgressContainer = styled(Vertical).attrs({ gap: 0 })`
  width: 100%;
  --active-color: var(--c-static-green-600);
`;

const Header = styled(SBHorizontal)`
  margin-bottom: var(--unit);
`;

export const ExpiredReferralStatusAction = ({ id }: { id: string }) => {
  const destroyReferral = useDestroyReferral();
  return (
    <Button
      color="red"
      size="small"
      onClick={() => {
        destroyReferral(id);
      }}
    >
      <FormattedMessage {...glossary.delete} />
    </Button>
  );
};

export const ProgressionBar = ({
  cardsBought,
  cardsRequirements,
}: {
  cardsBought: number;
  cardsRequirements: number;
}) => {
  return (
    <ProgressContainer>
      <>
        <Header>
          <LabelS color="var(--neutral-700)" as="p">
            <FormattedMessage
              id="RefereeItemContent.cardsCollected"
              defaultMessage="Cards collected"
            />
          </LabelS>
          <LabelS as="p">
            {Math.min(cardsBought, cardsRequirements)}/{cardsRequirements}
          </LabelS>
        </Header>
        <Progression
          hideCount
          count={cardsBought}
          max={cardsRequirements || undefined}
        />
      </>
    </ProgressContainer>
  );
};
